export default __webpack_public_path__ + "static/mobile_sek2_KV07-dd24c1f4d9273ab5833ee984832cf478.mp4";